export const SubscriptionPlan = {
  FREE: 0,
  PRO: 1,
  // 2 は将来の中間プラン用に予約
  MAX: 3,
  CROWDFUNDING: 9, // クラファン特典（手動付与）
} as const;

/** 有料プランか（Pro以上） */
export const isSubscribed = (plan: number): boolean =>
  plan >= SubscriptionPlan.PRO;

/** Pro以上か */
export const isPro = (plan: number): boolean =>
  plan >= SubscriptionPlan.PRO;

/** Max以上か */
export const isMax = (plan: number): boolean =>
  plan >= SubscriptionPlan.MAX;

/** EA機能にアクセスできるか（= Max以上） */
export const isEarlyAccess = (plan: number): boolean =>
  plan >= SubscriptionPlan.MAX;
